module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Account","delete_account":"Delete my account","delete_account_confirm":"Do you really want to delete your account forever? ","change_pass":"Change password"},"de":{"title":"Account","delete_account":"Meinen Account löschen","delete_account_confirm":"Möchten sie ihren Benutzeraccount wirklich unwiederruflich löschen?","change_pass":"Passwort ändern"}}')
  delete Component.options._Ctor
}
